import { faSquareList } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { FeatureGuard } from "../../components/Routes/Guards/FeatureGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { Features } from "../feature.enum";
import { IFeature } from "../iFeature";
import { SummaryPage } from "./SummaryPage";

export const summaryFeature: IFeature = {
  id: Features.Summary,
  route: {
    path: RouteConstants.Summary,
    element: (
      <FeatureGuard role={AppRole.SummarizationFeature}>
        <SummaryPage />
      </FeatureGuard>
    ),
  },
  menuItem: {
    label: translationKeys.feature.summary.link,
    breadCrumbTitle: translationKeys.feature.summary.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Summary].join("/")}`,
    path: RouteConstants.Summary,
    showFooter: true,
    icon: () => <FontAwesomeIcon icon={faSquareList} />,
  },
  card: (
    <FeatureCard
      featureKey={Features.Summary}
      requiresBudget={true}
      featureIcon={faSquareList}
      buttonIcon={faSquareList}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Summary}
    />
  ),
  role: AppRole.SummarizationFeature,
};
